import { SupportedTokenName } from "@mezo/sdk"

export type SwappableToken = Extract<
  SupportedTokenName,
  "MUSD" | "mBTC" | "mUSDT" | "mUSDC" | "mUSDe"
>
export enum SwapSettingsView {
  ASSET_SELECTOR = "swap-asset-selector",
  SLIPPAGE = "swap-slippage",
}

export enum SwapFormField {
  SELL_TOKEN = "sellToken",
  BUY_TOKEN = "buyToken",
}

export type SwapFromFieldData = {
  amount: string
  token: SwappableToken
}

export type SwapFormValue = {
  [SwapFormField.SELL_TOKEN]: SwapFromFieldData
  [SwapFormField.BUY_TOKEN]: SwapFromFieldData
  slippage: string
}
